<div class="mc-selection-list-header-bar">
  <mat-checkbox color="accent-vivid" [checked]="selectAllChecked" [disabled]="selectAllDisabled" [indeterminate]="selectAllIndeterminate" (change)="onSelectAllClicked()">Select All</mat-checkbox>
</div>